import { render } from "./User.vue?vue&type=template&id=475d2794"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=475d2794&lang=css"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__